var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background-fixed{position:fixed;top:0;left:0;z-index:-1}.backgound-container{position:relative;z-index:-1;height:100vh;width:100vw;background-image:url(" + escape(require("../svgs/bg.svg")) + ");background-repeat:repeat;background-size:cover}.background-bg{position:absolute;top:0;left:0;width:100%}.background-panda{position:absolute;top:30%;height:45%;left:0}.background-logo{position:absolute;right:20px;top:20px;width:38px}.background-title{position:absolute;top:26px;left:10px;animation:titlemove .7s 1}@keyframes titlemove{0%{left:-50px;opacity:0}to{left:10px;opacity:1}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/components/Background/Backgound.css
// module id = 342
// module chunks = 5